export enum Role {
  Operator = 10,
  Scheduler = 20,
  Viewer = 30,
  Admin = 40,
  Structure = 50,
  Support = 9000
}
